import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stethoscope, MapPin } from 'lucide-react';
import SearchableSelect from '../common/SearchableSelect';

// Top-bar Specialty + Address filters (Dashboard spec).
// These impact the whole dashboard — the selected values are lifted to DoctorDashboard
// and threaded down to every analytics component. Both are searchable comboboxes so
// long specialty/address lists stay usable.
const DashboardFilters = ({ specialtyId, addressTypeName, onSpecialtyChange, onAddressChange, filterOptions }) => {
  const { t } = useTranslation('dashboard');

  const specialties = filterOptions?.specialties || [];
  const addresses = filterOptions?.addresses || [];

  return (
    <div
      data-testid="dashboard-filters"
      className="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-2 sm:gap-3 w-full sm:w-auto"
    >
      {/* Specialty filter */}
      <SearchableSelect
        testId="dashboard-filter-specialty"
        icon={Stethoscope}
        value={specialtyId || ''}
        onChange={(v) => onSpecialtyChange(v || null)}
        placeholder={t('dashboard.all_specialties', 'All specialties')}
        searchPlaceholder={t('dashboard.search_specialty', 'Search specialty…')}
        className="sm:w-auto sm:min-w-[10rem]"
        options={specialties.map((s, idx) => ({
          value: s.specialtyId || '',
          label: s.specialtyName,
          _k: s.specialtyId || s.specialtyName || idx,
        }))}
      />

      {/* Address filter */}
      <SearchableSelect
        testId="dashboard-filter-address"
        icon={MapPin}
        value={addressTypeName || ''}
        onChange={(v) => onAddressChange(v || null)}
        placeholder={t('dashboard.all_addresses', 'All addresses')}
        searchPlaceholder={t('dashboard.search_address', 'Search address…')}
        className="sm:w-auto sm:min-w-[10rem]"
        options={addresses.map((a) => ({ value: a, label: a }))}
      />
    </div>
  );
};

export default DashboardFilters;
